import React from 'react';
import { getResponsiveImageUrl } from '../../utils/imageUrls';

const HotelImage = ({ blok, inSlider = false }) => {
  const imageUrlParams = {
    imageId: blok.image.id,
    parentWidth: 'w-full',
    inSlider: true,
    forceAspect: true,
  };

  let pictureClass = 'order-first sm:order-none';

  if (inSlider === true) pictureClass = 'aspect-square md:aspect-video';
  if (blok?.forceAspect === 'aspect-4/3')
    pictureClass = 'aspect-square md:aspect-4/3';

  return (
    <picture
      className={`flex flex-shrink-0 ${pictureClass} h-full w-full max-h-[95vh]`}
      key={blok._uid}
    >
      <source
        media="(max-width: 640px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '640px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(max-width: 768px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '768px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(max-width: 1024px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '1024px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(min-width: 1024px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '1440px',
          ...imageUrlParams,
        })}
      />
      <img
        loading="lazy"
        src={getResponsiveImageUrl({ screenWidth: '640px', ...imageUrlParams })}
        alt={blok.image.alt}
        className={`object-cover w-full h-full rounded`}
      />

      {/*       <source media="(min-width: 768px)" srcSet={`${fileNameDesktop}`} />
      <img
        loading="lazy" /*{
          itemSliderPosition > 2 || itemSliderPosition < numberOfSlides
            ? 'lazy'
            : undefined
        }
        src={`${filenameMobile}`}
        alt={blok.image.alt}
        className={`object-cover w-full h-full rounded`}
      /> 
      */}
    </picture>
  );
};

export default HotelImage;
